import { createApp } from 'vue'
import axios from 'axios'
import router from '@/router';

const app = createApp()
const service = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  baseURL: 'http://www.zjaia.com/base-api',
  // baseURL: 'http://192.168.1.90:8091',
  timeout: 10000 // request timeout
})
service.interceptors.request.use(
  (config) => {
    const requestHeader = {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
    config.headers = requestHeader

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// response interceptor 响应拦截器
service.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    return error.response
  }
)
export default service
